// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"89721f17","866":"69c36c2c"}[chunkId] + ".chunk.js";
};